import acc from "accounting"
import { Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import "./styles.less"

const { Title, Text } = Typography

const formatValue = (data) => {
  if (data.id === "all") {
    return acc.formatNumber(data.value, 0, ",", ".")
  }

  if (data.unit === "%") {
    return `${acc.formatNumber(data.value, 1, ",", ".")}%`
  }

  if (data.unit === "$") {
    return `$${acc.formatNumber(data.value, 2, ",", ".")}`
  }

  return acc.formatNumber(data.value, 0, ",", ".")
}

const DigitalCard = ({ data, onClick }) => {
  const { t } = useTranslation()

  const handleClick = () => {
    if (!data.isConnected) return
    onClick(data.id)
  }

  return (
    <Flex
      vertical
      gap={4}
      className={cls("digital-filter-card", {
        "digital-filter-card-active": false,
        disabled: !data.isConnected
      })}
      onClick={handleClick}
    >
      <Flex gap={4} vertical>
        <Flex gap={8} align="center">
          <Title level={5} type="secondary" style={{ margin: 0, fontSize: 14 }}>
            {t(data.title)}
          </Title>
        </Flex>
        <Flex gap={8} align="end">
          <Text strong style={{ fontSize: 20, lineHeight: 1.4 }}>
            {formatValue(data)}
          </Text>
        </Flex>
        <Flex gap={8} align="end">
          <Text type="secondary">{t(data.description)}</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default DigitalCard
